var exports = {
  "k": "xcc377c0b--6fe387--container",
};

module.exports = exports;
